export default __webpack_public_path__ + "static/media/car-fixing-7.6081764f.jpg";